import Tracing from "./Tracing";

(function() {
    if (!window.wlec) {
        return console.error('Tracing needs window.wlec instance');
    }

    if (!window.wlec.environment || !window.wlec.environment.sentry || !window.wlec.environment.sentry.enabled) {
        return;
    }

    let version = '__VERSION__';

    if (typeof window.wlec.environment.sentry.dsn !== 'string') {
        return console.error('sentry.dsn not set');
    }

    if (typeof window.wlec.environment.name !== 'string') {
        return console.error('environment not set');
    }

    if (version.length < 1) {
        version = 'youtix-frontend@dev';
    }

    if (window.wlec.environment.sentry.dsn) {
        Tracing.getInstace()
            .addDSN(window.wlec.environment.sentry.dsn)
            .setConfig('environment', window.wlec.environment.name || 'staging')
            .setConfig('tracesSampleRate', 1.0)
            .setConfig('debug', window.wlec.environment.sentry.debug === 'true')
            .setConfig('sampleRate', window.wlec.environment.sentry.sampleRate || 0.3)
            .setConfig('release', version)
            .init();

        window.addEventListener("error", Tracing.errorHandler);
    }
})();
